import { render, staticRenderFns } from "./deviceBorrowExtend.vue?vue&type=template&id=b5141c78&scoped=true&"
import script from "./deviceBorrowExtend.vue?vue&type=script&lang=js&"
export * from "./deviceBorrowExtend.vue?vue&type=script&lang=js&"
import style0 from "./deviceBorrowExtend.vue?vue&type=style&index=0&id=b5141c78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5141c78",
  null
  
)

export default component.exports